import type React from "react";

import { formatTimeline } from "@ui/utils/formatTime/formatTime";
import classNames from "classnames";

import styles from "../VideoPlayer.module.scss";

type VideoPlayerInfoProps = {
  description?: string;
  showDuration: boolean;
  duration: number;
};

export const VideoPlayerInfo: React.FC<VideoPlayerInfoProps> = ({ description, showDuration, duration }) => {
  const renderDescription = () => {
    if (!description) {
      return null;
    }

    return (
      <span data-testid="videoDescriptionBlock" className={styles.videoPlayerDescription}>
        {description}
      </span>
    );
  };

  const renderDuration = () => {
    if (!showDuration) {
      return null;
    }

    return (
      <span data-testid="videoDurationblock" className={styles.VideoPlayerDuration}>
        {formatTimeline(duration)}
      </span>
    );
  };

  return (
    <>
      {(description?.length || showDuration) && (
        <div className={classNames(styles.videoPlayerInfo)}>
          {renderDescription()}
          {renderDuration()}
        </div>
      )}
    </>
  );
};
